// ADD HERE NAME OF OLD VERSION OF THE SOP TO MAKE IF GREY AND PREVENT FROM DOWNLOADING.
// it will automatically disable this function in the UI

export default {
  "Line 1": [],
  "Line 2 & 4": [],
  "Line 3": [],
  "Shop 1": [],
};
